/* eslint-disable no-console */
import { datadogRum } from '@datadog/browser-rum';
import { isLocalEnvironment } from '../../environment';
import { generateLogMessagePrefix, getMfeName, getSafeError, getSafeErrorContext, getSafeUserContext, logLoggerFailure, } from './utils';
/**
 * @param name - The name of the error. Must be in PascalCase, e.g. "ViewRenderError".
 * @param err - The error object to log.
 * @param context - The context to log.
 * @returns void
 */
export const error = (name, err, context) => {
    const safeError = getSafeError(err);
    safeError.name = name;
    const safeErrorContext = getSafeErrorContext(safeError);
    const safeUserContext = getSafeUserContext(context);
    const safeContext = {
        ...safeErrorContext,
        ...safeUserContext,
    };
    const mfeName = getMfeName(safeContext);
    if (isLocalEnvironment()) {
        const messagePrefix = generateLogMessagePrefix(mfeName, 'ERROR');
        console.error(messagePrefix, safeError);
        return;
    }
    try {
        datadogRum.addError(safeError, safeContext);
    }
    catch {
        logLoggerFailure('ERROR');
        const messagePrefix = generateLogMessagePrefix(mfeName, 'ERROR');
        console.error(messagePrefix, safeError);
    }
};
